// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"5ef3757e","380":"bf73e3b6","822":"79dfa892","862":"3a17156e","978":"f7b42404"}[chunkId] + ".chunk.css";
};